import styled from "styled-components"
import { StyledModal } from "app/static/frontend/components/Modal/style"

export const AlertModal = styled(StyledModal)`
    /* Same level as sweetalert */
    &.ReactModal__Overlay {
        z-index: 10000;
    }
`
